import React from 'react';

const BarLegend = ({ width, height, xScale, yScale, margin, data }) => (
    <svg
        width={width - 50}
        height={height}
        className="fill-current text-gray-700 dark:text-white">
        <g className="fill-current text-gray-200"
            transform={`translate(${width * 1 / 2},${height * 2 / 3})`}>
            <rect key="legend" width="130" height="60" rx="5" />
            <rect x={10} y={20} width="20" height="20"
                className="fill-current text-blue-300 dark:text-gray-400"
                rx="3"
            />
            <text x={35} y={35}
                className="text-xs text-black">Unspoiled Item</text>
        </g>
        <text x={(width - margin.left - margin.right) / 2} y={margin.top * 0.3} key="xScale" className="xs:text-xs text-base font-bold">Fruit Counts →</text>
        <text
            key="yScale"
            className="xs:text-xs text-base font-bold"
            transform={`translate(${margin.left * 0.3},${(height - margin.bottom - margin.top) / 2}) rotate(-90)`}>Fruits</text>
        {xScale.ticks().map((a, index) => (
            <g transform={`translate(${margin.left},0)`} key={`gTicks-${index}`} className="stroke-current text-gray-400 dark:text-gray-50">
                <line
                    key={index}
                    x1={xScale(a)}
                    x2={xScale(a)}
                    y1={margin.top + 5}
                    y2={margin.top * 0.9}
                />
                <text
                    key={`xScaleText-$index}`}
                    textAnchor="middle"
                    x={xScale(a)}
                    y={(margin.top * 0.75)}
                    className="text-gray-700 dark:text-white text-xs">
                    {a}
                </text>
            </g>
        ))}
        {
            yScale.domain().map((a, index) => (
                <g key={`gTicks-${index}`} className="stroke-current text-gray-400 dark:text-gray-50">
                    <line
                        key={`yScale-${index}`}
                        x1={margin.left + 5}
                        x2={margin.left * 0.9}
                        y1={yScale(a) + yScale.bandwidth() / 2}
                        y2={yScale(a) + yScale.bandwidth() / 2}
                    />
                    <text
                        key={`yScaleText-${index}`}
                        textAnchor="end"
                        dy="0.3em"
                        x={margin.left * 0.75}
                        y={yScale(a) + yScale.bandwidth() / 2}
                        className="text-gray-700 dark:text-white text-xs">
                        {a}
                    </text>
                </g>
            ))
        }
        {
            data.map((a, index) => (
                <g key={`group-${index}`} transform={`translate(0,0)`}>
                    <rect
                        key={index}
                        x={margin.left}
                        y={yScale(a.name)}
                        width={xScale(a.count)}
                        height={yScale.bandwidth()}>
                        <title key={`title-${index}`}>
                            {`Good Items:${a.good}
Total Items:${a.count}`}
                        </title>
                    </rect>
                    <rect
                        className="fill-current text-blue-300 dark:text-gray-400"
                        key={`good-${index}`}
                        x={margin.left}
                        y={yScale(a.name)}
                        width={xScale(a.good)}
                        height={yScale.bandwidth()}>
                        <title>
                            {`Good Items:${a.good}
Total Items:${a.count}`}
                        </title>
                    </rect>
                    <text  key={`text2All-${index}`} textAnchor="middle" dx="0.8em" className="text-xs text-white dark:text-gray-700" x={xScale(a.count) + 20} y={yScale(a.name) + yScale.bandwidth() / 2}>{a.count}</text>
                </g>
            ))
        }
    </svg>
)

export default BarLegend